/** Deutsche Texte. Schlüssel gelten auch für en.ts. Platzhalter in {geschweiften Klammern}. */
export const de = {
  // Allgemein
  'app.name': 'Financial Tool',
  'app.area': 'Bereich',
  "mg.areaTarget": "Zielmarge Bereich",
  "mg.col.target": "Ziel",
  "mg.targetOf": "Zielmarge {p}",
  "mg.targetInvalid": "Bitte 0 bis 100 eingeben.",
  "mg.targetArea": "(Bereich)",
  "mg.targetDefault": "(Standard)",
  "mg.targetHint": "Zielmarge ändern; leer lassen = Bereichsziel bzw. Standard",
  "mg.title": "Marge",
  "mg.lead": "Umsatz, Kosten und Marge je Projekt aus dem Power-BI-Export (Workday „Project Margin“). Es erscheinen nur Projekte mit Umsatz; Monate ohne Umsatz gelten als offen und zählen nicht mit.",
  "mg.import": "Export einlesen",
  "mg.year": "Jahr",
  "mg.target": "Zielmarge",
  "mg.last": "Zuletzt eingelesen am {at} von {by} ({file}), Export bis {m}",
  "mg.empty": "Noch keine Margendaten. Bitte den Power-BI-Export einlesen.",
  "mg.emptyYear": "Für {y} gibt es keine Projekte mit Umsatz.",
  "mg.kpi.ns": "Umsatz",
  "mg.kpi.nsSub": "Net Sales, {n} Projekte",
  "mg.kpi.cost": "Projektkosten",
  "mg.kpi.costSub": "Personal und Fremdleistung",
  "mg.kpi.margin": "Projektmarge",
  "mg.kpi.marginSub": "Zielmarge {p}",
  "mg.kpi.hours": "Stunden",
  "mg.kpi.hoursSub": "davon {n} kostenlos",
  "mg.kpi.perHour": "Je Stunde",
  "mg.kpi.perHourSub": "Umsatz / Kosten je Stunde",
  "mg.months": "Marge je Monat",
  "mg.legendNs": "Umsatz",
  "mg.legendCost": "Kosten",
  "mg.monthOpen": "offen",
  "mg.monthHint": "Prozent = Marge des Monats",
  "mg.find": "Auffälligkeiten",
  "mg.find.none": "Keine Auffälligkeiten.",
  "mg.lvl.urgent": "Dringend",
  "mg.lvl.check": "Prüfen",
  "mg.find.negative": "{p}: im {m} negative Marge ({v})",
  "mg.find.falling": "{p} fällt zuletzt: {v} im {m}, im Schnitt {avg}",
  "mg.find.below": "{p} liegt im Jahr nur bei {v} (Ziel {g})",
  "mg.hidden": "{n} Projekte nur mit Kosten oder Stunden sind ausgeblendet.",
  "mg.projects": "Projekte",
  "mg.count": "{n} von {all} · nach Umsatz",
  "mg.f.all": "Alle",
  "mg.f.crit": "Kritisch",
  "mg.f.watch": "Beobachten",
  "mg.f.ok": "Im Ziel",
  "mg.state.crit": "kritisch",
  "mg.state.watch": "beobachten",
  "mg.state.ok": "im Ziel",
  "mg.falling": "fällt zuletzt",
  "mg.noTool": "nicht im Tool",
  "mg.col.project": "Projekt",
  "mg.col.customer": "Kunde",
  "mg.col.hours": "Stunden",
  "mg.col.ns": "Umsatz",
  "mg.col.cost": "Kosten",
  "mg.col.margin": "Marge",
  "mg.col.pct": "Marge %",
  "mg.col.perHour": "€/Std.",
  "mg.col.trend": "Verlauf",
  "mg.sum": "Summe",
  "mg.customers": "Nach Kunde",
  "mg.custLine": "{ns} Umsatz · {m} Marge · {h} Std.",
  "mg.im.title": "Power-BI-Export einlesen",
  "mg.im.lead": "In Power BI die Tabelle „Project Margin“ (project, Calendar_Period, Commercial Hours, Net Sales, Project Costs …) als Excel exportieren und hier ablegen. Neue Monate kommen dazu, geänderte Werte werden aktualisiert, Monate, die im Export fehlen, bleiben stehen. Vor dem Übernehmen siehst du alle Änderungen.",
  "mg.im.drop": "Excel-Datei hierher ziehen oder klicken",
  "mg.im.checking": "Prüfe …",
  "mg.im.close": "Schließen",
  "mg.im.state.new": "neu",
  "mg.im.state.changed": "geändert",
  "mg.im.state.unchanged": "unverändert",
  "mg.im.newMonths": "Neue Monate: {m}",
  "mg.im.noNewMonths": "Kein neuer Monat",
  "mg.im.range": "Export: {from} bis {to} · {n} Zeilen",
  "mg.im.skipped": "{n} Zeilen übersprungen",
  "mg.im.apply": "Übernehmen ({n})",
  "mg.im.applying": "Übernehme …",
  "mg.im.nothing": "Keine Änderungen – alles schon im Tool.",
  "mg.im.applied": "Übernommen: {new} neu, {changed} aktualisiert",
  "mg.im.unmatched": "{n} Workday-Projekte ohne Projekt im Tool (werden trotzdem übernommen): {list}",
  "mg.im.showUnchanged": "Unveränderte zeigen",
  "mg.im.col.month": "Monat",
  'app.loading': 'Lade …',
  'app.toLogin': 'Weiter zur Anmeldung …',
  'app.noAccess.title': 'Noch kein Zugang',
  'app.noAccess.text': 'Dein Konto ist für das Financial Tool noch nicht freigeschaltet. Bitte wende dich an Matthias Brunner.',
  'app.signedInAs': 'Angemeldet als {email}',
  'app.logout': 'Abmelden',
  'app.down.title': 'Das Tool ist gerade nicht erreichbar',
  'app.down.text': '{reason}. Bitte in ein paar Minuten neu laden.',
  'app.reload': 'Neu laden',
  'app.serverStatus': 'Server antwortet mit {status}',
  'app.serverDown': 'Server nicht erreichbar',
  'app.toLight': 'Zu Hell wechseln',
  'app.toDark': 'Zu Dunkel wechseln',
  'app.theme': 'Hell / Dunkel',
  'app.lang': 'Sprache',
  'app.toStart': 'Zum Start',
  'app.modules': 'Module',
  'crumb.root': 'Financial Tool · {area}',
  'crumb.admin': 'Financial Tool · CBS · Verwaltung',

  'nav.start': 'Start',
  'nav.orders': 'Bestellungen',
  'nav.projects': 'Projekte',
  'nav.invoicing': 'Invoicing',
  'nav.issues': 'Offene Punkte',
  'nav.forecast': 'Forecast',
  'nav.margin': 'Marge',
  'nav.soon': 'bald',
  'nav.admin': 'Verwaltung',
  'nav.issuesBadge': '{n} zu prüfen',

  'common.cancel': 'Abbrechen',
  'common.save': 'Speichern',
  'common.saving': 'Speichere …',
  'common.close': 'Schließen',
  'common.all': 'Alle',
  'common.search': 'Suche',
  'common.reset': 'Zurücksetzen',
  'common.customer': 'Kunde',
  'common.project': 'Projekt',
  'common.pm': 'PM',
  'common.status': 'Status',
  'common.choose': 'Bitte wählen',
  'common.chooseCustomerFirst': 'Erst Kunde wählen',
  'common.archive': 'Löschen',
  'common.archiveConfirm': 'Wirklich löschen?',
  'common.archiving': 'Lösche …',
  'common.edit': 'Bearbeiten',
  'common.open': 'Öffnen',
  'common.sum': 'Summe',
  'common.noNumber': 'ohne Nr.',
  'common.myProjects': 'Meine Projekte',
  'common.withoutPm': 'Ohne PM',
  'common.filter': 'Filter',
  'common.none': 'Keine.',
  'common.amount': 'Betrag',
  'common.date': 'Datum',
  'common.quarter': 'Quartal',
  'common.order': 'Bestellung',
  'common.warranty': 'Gewährleistung',
  'common.export': 'Excel-Export',
  'common.exporting': 'Erstelle Excel …',
  'common.notFound.title': 'Seite nicht gefunden',

  'status.warranty': 'Gewährleistung',
  'status.overdrawn': 'Überzogen',
  'status.settled': 'Abgerechnet',
  'status.nearlyUsed': 'Fast verbraucht',
  'status.unbilled': 'Ohne Rechnung',
  'status.active': 'Aktiv',
  'status.open': 'Offenes Volumen',

  'cp.collapse': 'Einklappen',
  'cp.expand': 'Ausklappen',
  'cp.collapseAll': 'Alle einklappen',
  'cp.expandAll': 'Alle ausklappen',
  'fc.kpisTitle': 'Kennzahlen {y}',
  'fc.sum.avg': 'Ø je Monat',
  'fc.cols': 'Spalten',
  'fc.cols.m': 'Monate',
  'fc.cols.q': 'Quartale',
  'fc.cols.s': 'Nur Summen',
  'dh.tableTitle': 'Bereiche ({n})',
  'inbox.toReview': 'zu prüfen',
  'order.projectsN': '{n} Projekte',
  'order.usedPct': '{p} % verbraucht',
  'order.historyN': '{n} Einträge',
  'mg.kpisTitle': 'Kennzahlen {y}',
  'mg.custN': '{n} Kunden',
  'pa.groupsN': '{n} Kostengruppen',
  'role.admin': 'Admin',
  'role.pm': 'Projektmanager',
  'role.reader': 'Lesend',
  'role.finance': 'Finance',
  'uf.financeHelp': 'Finance sieht in den gewählten Bereichen alles – auch Marge, Monatsstände und Financial Report – und ändert nur Rechnungen: Zahlungsstatus, Bezahlt am, Warranty und Workday-Abgleich. Bestellungen, Verträge und Projekte nur ansehen.',
  'shell.finance': 'Finance · Rechnungen bearbeiten, sonst nur ansehen',
  'if.financeOnly': 'Als Finance änderst du hier Zahlungsstatus, Fälligkeit, Bezahlt am und Warranty.',

  // Start
  'start.hello': 'Guten Tag, {name}',
  'start.sub': 'Bereich {area} · angemeldet als {role}',
  'start.statusTitle': 'Stand des Aufbaus',
  'start.statusText': 'Das Tool ist ab jetzt die Basis für Bestellungen und Rechnungen. Die Excel wird nicht mehr gepflegt.',
  'start.done': 'Erledigt',
  'start.open': 'Offen',
  'start.check': 'Prüfe …',
  'start.error': 'Fehler',
  'start.login': 'Anmeldung mit {email}',
  'start.db': 'Datenbankverbindung',
  'start.version': 'Version {v}',
  'start.import': 'Datenimport 2026 aus der Excel',
  'start.edit': 'Bestellungen und Rechnungen anlegen, bearbeiten, mit Verlauf',
  'start.admin': 'Verwaltung: Personen freischalten, PMs und Ziele zuordnen',
  'start.lang': 'Deutsch und Englisch',
  'start.projects': 'Projekte & Ziele (Übersicht mit Fortschritt)',
  'start.pdf': 'Bestellung aus PDF einlesen',
  'placeholder.text': 'Diese Ansicht entsteht in {step}. Die Gestaltung folgt Entwurf v4.',
  'placeholder.next': 'einem der nächsten Schritte',

  // Bestellungen
  'orders.title': 'Bestellungen',
  'orders.new': 'Neue Bestellung',
  'orders.searchPh': 'Bestellnr., Projekt …',
  'orders.empty': 'Keine Bestellung entspricht diesen Filtern.',
  'orders.col.number': 'Bestellnr.',
  'orders.col.orderedOn': 'Bestellt am',
  'orders.col.lastInvoice': 'Letzte Rechnung',
  'orders.col.volume': 'Volumen',
  'orders.col.billed': 'Abgerechnet',
  'orders.col.rest': 'Rest',
  'orders.col.usage': 'Verbrauch',
  'orders.count': '{n} Bestellungen',

  'order.kind.order': 'Kundenbestellung',
  'order.kind.warranty': 'Gewährleistung',
  'order.customer': 'Kunde',
  'order.orderedOn': 'Bestellt am',
  'order.service': 'Leistung',
  'order.invoices': 'Rechnungen',
  'order.used': '{p} verbraucht',
  'order.note': 'Notiz',
  'order.alloc': 'Verteilung auf Projekte',
  'order.allocHint': 'Summe = Bestellvolumen',
  'order.col.share': 'Anteil',
  'order.unallocated': 'Ohne Anteil',
  'order.setShare': 'Anteil festlegen',
  'order.noLines': 'Noch keine Positionen. Über „Bearbeiten“ Projekte und Beträge eintragen.',
  'order.invoicesTitle': 'Rechnungen ({n})',
  'order.addInvoice': 'Rechnung erfassen',
  'order.noInvoices': 'Noch keine Rechnung auf dieser Bestellung.',
  'order.history': 'Änderungsverlauf',
  'order.historyHint': 'Wer hat wann was geändert',
  'order.fromImport': 'aus Excel-Import',
  'order.fromWorkday': 'aus Workday-Import',
  'order.saved': 'Bestellung gespeichert',
  'invoice.saved': 'Rechnung gespeichert',

  'hist.order': 'Bestellung',
  'hist.line': 'Position {ref}',
  'hist.invoice': 'Rechnung {ref}',
  'hist.create': '{what} angelegt',
  'hist.update': '{what} geändert',
  'hist.delete': '{what} entfernt',
  'hist.restore': '{what} wiederhergestellt',
  'hist.otherOrder': 'andere Bestellung',
  'field.order_number': 'Bestellnummer',
  'field.kind': 'Art',
  'field.customer_id': 'Kunde',
  'field.order_date': 'Bestellt am',
  'field.service_from': 'Leistung von',
  'field.service_to': 'Leistung bis',
  'field.note': 'Notiz',
  'field.amount_cents': 'Betrag',
  'field.project_id': 'Projekt',
  'field.order_id': 'Bestellung',
  'field.invoice_number': 'Workday-Nr.',
  'field.invoice_date': 'Datum',

  // Formular Bestellung
  'of.new': 'Neue Bestellung',
  'of.edit': 'Bestellung {n} bearbeiten',
  'of.kind': 'Art',
  'of.number': 'Bestellnummer (PO)',
  'of.numberPh': 'z. B. F46XW9J',
  'of.orderedOn': 'Bestellt am',
  'of.from': 'Leistung von',
  'of.to': 'Leistung bis',
  'of.alloc': 'Verteilung auf Projekte',
  'of.chooseProject': 'Projekt wählen',
  'of.lineProject': 'Projekt Position {n}',
  'of.lineAmount': 'Betrag Position {n} in Euro',
  'of.lineRemove': 'Position {n} entfernen',
  'of.addProject': '+ Projekt hinzufügen',
  'of.volume': 'Volumen',
  'of.note': 'Notiz',
  'of.notePh': 'z. B. Nachbestellung zu F46XW9J, Ansprechpartner …',
  'of.err.customer': 'Bitte einen Kunden wählen.',
  'of.err.number': 'Bitte die Bestellnummer (PO) eintragen.',
  'of.err.project': 'Bei jeder Position ein Projekt wählen.',
  'of.err.amount': 'Bei jeder Position einen gültigen Betrag eintragen, z. B. 120.000,00.',
  'of.err.lines': 'Mindestens eine Position mit Projekt und Betrag eintragen.',

  // Rechnungen
  'inv.title': 'Invoicing',
  'inv.add': 'Rechnung erfassen',
  'inv.searchPh': 'Workday-Nr., Bestellnr. …',
  'inv.period': 'Zeitraum',
  'inv.order': 'Bestellung',
  'inv.withoutOrder': 'Ohne Bestellung',
  'inv.noOrder': 'Keine Bestellung',
  'inv.empty': 'Keine Rechnungen für diese Auswahl.',
  'inv.col.number': 'Workday-Nr.',
  'inv.count': '{n} Rechnungen',
  'if.title': 'Rechnung {n}',
  'if.number': 'Workday-Nr.',
  'if.numberPh': 'z. B. 002CINV2026100101',
  'if.date': 'Rechnungsdatum',
  'if.amount': 'Betrag netto (€)',
  'if.err.number': 'Bitte die Workday-Rechnungsnummer eintragen.',
  'if.err.project': 'Bitte ein Projekt wählen.',
  'if.err.amount': 'Bitte einen gültigen Betrag eintragen, z. B. 12.500,00.',

  // Offene Punkte
  'issues.title': 'Offene Punkte',
  'issues.lead': 'Das Tool prüft die Daten laufend. Ein Punkt verschwindet von selbst, sobald er behoben ist, z. B. wenn eine Nachbestellung erfasst oder eine Rechnung richtig zugeordnet ist.',
  'issues.empty': 'Nichts offen.',
  'issues.level.neg': 'Dringend',
  'issues.level.crit': 'Prüfen',
  'issues.level.info': 'Hinweis',
  'issues.warrantySuffix': ' (Gewährleistung)',
  'issue.overdrawn.t': 'Bestellung {order} ist zu {pct} abgerechnet',
  'issue.overdrawn.d': '{billed} von {volume}. Fehlt eine Nachbestellung oder ist eine Rechnung falsch zugeordnet?',
  'issue.nearlyUsed.t': 'Bestellung {order} ist fast verbraucht ({pct})',
  'issue.nearlyUsed.d': 'Noch {rest} offen. Nachbestellung beim Kunden anfragen?',
  'issue.lineOverdrawn.t': '{project}: Anteil an {order} überzogen ({pct})',
  'issue.lineOverdrawn.d': '{billed} abgerechnet bei {volume} Anteil. Verteilung anpassen?',
  'issue.noLines.t': 'Bestellung {order} hat keine Positionen',
  'issue.noLines.d': 'Volumen und Projekt fehlen. Bitte die Verteilung auf Projekte eintragen.',
  'issue.notAllocated.t': '{project}: Rechnungen auf {order} ohne Anteil',
  'issue.notAllocated.d': '{billed} abgerechnet, aber die Bestellung hat für dieses Projekt keine Position. Anteil festlegen oder Rechnung umhängen.',
  'issue.withoutOrder.t': '{project}: {count} Rechnung(en) ohne Bestellung',
  'issue.withoutOrder.d': '{billed}. Normal bei Kunden ohne PO, sonst Bestellung zuordnen.',
  'issue.noPm.t': '{count} Projekt(e) ohne PM',
  'issue.noPm.d': '{projects}. Ohne PM erscheint ein Projekt bei niemandem unter „Meine Projekte“.',
  'issue.endingSoon.t': "Laufzeit von {order} endet in {days} Tagen",
  'issue.endingSoon.d': "Leistungszeitraum bis {date}, kein Folgeabruf für {projects}. Jetzt Folgebestellung anfragen.",

  // Verwaltung
  'admin.title': 'Verwaltung',
  'admin.tab.users': 'Personen',
  'admin.tab.projects': 'Projekte & Zuständigkeiten',
  'admin.tab.import': 'Excel-Import',
  'users.lead': 'Wer hier freigeschaltet ist, kann sich mit seinem intive-Konto anmelden. Die E-Mail-Adresse muss genau der Microsoft-Anmeldung entsprechen.',
  'users.add': 'Person hinzufügen',
  'users.col.name': 'Name',
  'users.col.email': 'E-Mail',
  'users.col.role': 'Rolle',
  'users.col.projects': 'Projekte',
  'users.col.state': 'Status',
  'users.active': 'Aktiv',
  'users.inactive': 'Deaktiviert',
  'users.pmOf': '{n} als PM',
  'users.deputyOf': '{n} als Vertretung',
  'users.deactivate': 'Deaktivieren',
  'users.deactivateConfirm': 'Wirklich deaktivieren?',
  'users.restore': 'Wieder aktivieren',
  'users.you': '(du)',
  'users.roleHelp': 'Admin: alles inkl. Verwaltung · Projektmanager: Bestellungen und Rechnungen bearbeiten · Finance: alles ansehen (inkl. Marge, Report), Zahlungen und Warranty pflegen · Lesend: nur ansehen · Delivery Head: alle Bereiche ansehen, mit Gesamtübersicht',
  'uf.new': 'Person hinzufügen',
  'uf.edit': '{n} bearbeiten',
  'uf.name': 'Name',
  'uf.namePh': 'Vorname Nachname',
  'uf.email': 'E-Mail (intive-Konto)',
  'uf.emailPh': 'vorname.nachname@intive.com',
  'uf.role': 'Rolle',
  'uf.err.name': 'Bitte den Namen eintragen.',
  'uf.err.email': 'Bitte eine gültige E-Mail-Adresse eintragen.',
  'uf.saved': 'Person gespeichert',
  'uf.deactivated': 'Person deaktiviert',
  'uf.restored': 'Person wieder aktiv',

  'projects.lead': 'Projekte im Bereich {area}. Der PM hängt am Projekt. Bestellungen und Rechnungen übernehmen ihn automatisch. Die Vertretung sieht das Projekt ebenfalls unter „Meine Projekte“.',
  'projects.add': 'Neues Projekt',
  'projects.year': 'Jahr',
  'projects.col.domain': 'Domäne',
  'projects.col.deputy': 'Vertretung',
  'projects.col.since': 'PM seit',
  'projects.col.target': 'Jahresziel {y}',
  'projects.none': 'Keine Projekte.',
  'pf.new': 'Neues Projekt anlegen',
  'pf.edit': 'Projekt {n} bearbeiten',
  'pf.customer': 'Kunde',
  'pf.newCustomer': '+ Neuer Kunde …',
  'pf.newCustomerName': 'Name des neuen Kunden',
  'pf.name': 'Projektname',
  'pf.domain': 'Domäne',
  'pf.domainPh': 'z. B. Data & Analytics',
  'pf.pm': 'PM',
  'pf.deputy': 'Vertretung',
  'pf.noPm': '– Kein PM –',
  'pf.noDeputy': '– Keine –',
  'pf.target': 'Jahresziel {y} (€)',
  'pf.targetPh': 'leer = kein Ziel',
  'pf.err.customer': 'Bitte einen Kunden wählen oder neu anlegen.',
  'pf.err.name': 'Bitte den Projektnamen eintragen.',
  'pf.err.pm': 'Ein neues Projekt braucht einen PM.',
  'pf.err.target': 'Bitte ein gültiges Jahresziel eintragen, z. B. 250.000,00, oder leer lassen.',
  'pf.saved': 'Projekt gespeichert',

  // Bereiche
  'app.noArea.title': 'Noch keinem Bereich zugeordnet',
  'app.noArea.text': 'Du bist angemeldet, aber noch keinem Bereich zugeordnet. Deshalb siehst du keine Bestellungen, Projekte oder Rechnungen. Bitte wende dich an Matthias Brunner.',
  'app.noArea.admin': 'Du bist keinem Bereich zugeordnet und siehst deshalb keine Daten. Ordne dich unter Verwaltung → Personen einem Bereich zu.',
  'app.areaSwitch': 'Bereich wechseln',
  'users.col.areas': 'Bereiche',
  'users.noArea': 'kein Bereich',
  'uf.areas': 'Bereiche',
  'uf.areasHelp': 'Die Person sieht nur Bestellungen, Projekte und Rechnungen dieser Bereiche. Ohne Bereich sieht sie nichts.',
  'admin.tab.areas': 'Bereiche',
  'areas.lead': 'Jeder Bereich hat eigene Kunden, Projekte, Bestellungen und Rechnungen. Wer einem Bereich zugeordnet ist, sieht alles darin, sonst nichts.',
  'areas.add': 'Neuer Bereich',
  'areas.col.name': 'Name',
  'areas.col.members': 'Personen',
  'areas.col.projects': 'Projekte',
  'af.new': 'Neuer Bereich',
  'af.edit': 'Bereich {n} umbenennen',
  'af.name': 'Name',
  'af.namePh': 'z. B. CBS',
  'af.hint': 'Du wirst dem neuen Bereich automatisch zugeordnet. Weitere Personen ordnest du unter „Personen“ zu.',
  'af.err.name': 'Bitte einen Namen eintragen.',
  'af.saved': 'Bereich gespeichert',
  'pf.pmHelp': 'Zur Auswahl stehen Personen, die dem Bereich {area} zugeordnet sind.',

  // Projekte & Ziele
  'pz.title': 'Projekte & Ziele',
  'pz.year': 'Jahr',
  'pz.allPms': 'Alle PMs',
  'pz.me': '(ich)',
  'pz.legend.billed': 'abgerechnet',
  'pz.legend.ordered': 'bestellt',
  'pz.legend.pace': 'Soll heute ({p})',
  'pz.count': '{n} Projekte',
  'pz.col.target': 'Ziel',
  'pz.col.ordered': 'Bestellt',
  'pz.col.billed': 'Abgerechnet',
  'pz.col.open': 'Offen bestellt',
  'pz.col.progress': 'Fortschritt',
  'pz.col.reach': 'Zielerreichung',
  'pz.health.noTarget': 'Ohne Ziel',
  'pz.health.uncovered': 'Ziel ohne Deckung',
  'pz.health.behind': 'Hinter Soll',
  'pz.health.onTrack': 'Im Plan',
  'pz.custOf': '{billed} von {target} · {p}',
  'pz.empty': 'Keine Projekte für diese Auswahl.',
  'pz.removeFilter': 'Filter entfernen',
  'pz.healthHelp': 'Ziel ohne Deckung: weniger als 50 % des Ziels bestellt. Hinter Soll: weniger als 80 % des heutigen Solls abgerechnet.',
  'pz.trackLabel': '{project}: {billed} abgerechnet, {ordered} bestellt, Ziel {target}',
  // Cockpit
  'ck.kpis': 'Kennzahlen {y}',
  'ck.target': 'Jahresziel {y}',
  'ck.targetSub': '{n} Projekte mit Ziel',
  'ck.ordered': 'Bestellvolumen',
  'ck.orderedSub': '{p} des Ziels bestellt',
  'ck.billed': 'Abgerechnet',
  'ck.billedSub': '{p} vom Ziel · Soll heute {pace}',
  'ck.open': 'Offenes Bestellvolumen',
  'ck.openSub': 'noch abzurechnen',
  'ck.scopeAll': 'Alle',
  'ck.scopeMine': 'Meine Projekte',
  'ck.myIssues': 'Offene Punkte',
  'ck.allIssues': 'Alle anzeigen →',
  'ck.noIssues': 'Nichts offen.',
  'ck.quarters': 'Abgerechnet pro Quartal {y}',
  'ck.quarterHint': 'Klick öffnet die Rechnungen',
  'ck.recent': 'Letzte Rechnungen',
  'ck.allInvoices': 'Invoicing öffnen →',
  'ck.projectsAtRisk': 'Projekte hinter Soll oder ohne Deckung',
  'ck.allProjects': 'Projekte & Ziele →',
  'ck.noRisk': 'Alle Projekte im Plan.',

  // PDF
  'pdf.fromPdf': 'Aus PDF einlesen',
  'pdf.reading': 'Lese PDF …',
  'pdf.title': 'Bestellung aus PDF',
  'pdf.check': 'Vorschlag aus „{file}“. Bitte alle Werte prüfen, bevor du speicherst. Die PDF wird an der Bestellung abgelegt.',
  'pdf.warn.orderNumber': 'Bestellnummer nicht erkannt',
  'pdf.warn.orderDate': 'Bestelldatum nicht erkannt',
  'pdf.warn.customer': 'Kunde nicht erkannt',
  'pdf.warn.positions': 'Keine Positionen mit Betrag erkannt',
  'pdf.warn.totalMismatch': 'Summe der Positionen weicht vom Gesamtbetrag der PDF ab ({total})',
  'pdf.warn.project': 'Nicht jede Position konnte einem Projekt zugeordnet werden',
  'pdf.exists': 'Die Bestellnummer gibt es schon in diesem Bereich.',
  'pdf.openExisting': 'Vorhandene Bestellung öffnen',
  'pdf.lineFrom': 'aus PDF: {text}',
  'pdf.drop': 'Bestell-PDF vom Rechner hierher ziehen oder auswählen – die Felder werden automatisch ausgefüllt',
  'pdf.dropAgain': '„{file}“ eingelesen · andere PDF wählen',
  'pdf.docs': 'Dokumente',
  'pdf.open': 'PDF öffnen',
  'pdf.replace': 'PDF ersetzen',
  'pdf.upload': 'PDF ablegen',
  'pdf.none': 'Noch keine Bestell-PDF abgelegt.',
  'pdf.saved': 'PDF abgelegt',
  'field.pdf_name': 'PDF',

  // Workday
  'wd.button': 'Workday-Import',
  'wd.title': 'Rechnungen aus Workday übernehmen',
  'wd.lead': 'Exportiere in Workday den Rechnungsbericht (z. B. „Find Customer Invoices“) mit Rechnungsnummer, Datum, Projekt, Kunden-PO und Nettobetrag als Excel oder CSV und lade ihn hier hoch. Erst kommt ein Probelauf. Es werden nur neue Rechnungen angelegt; was schon im Tool steht (aus Excel, von Hand oder früher importiert), wird nie überschrieben. Zuordnung zur Bestellung über die PO-Nummer.',
  'wd.drop': 'Workday-Export (.xlsx oder .csv) hierher ziehen oder auswählen',
  'wd.check': 'Probelauf',
  'wd.checking': 'Prüfe …',
  'wd.apply': '{n} Rechnungen übernehmen',
  'wd.applying': 'Übernehme …',
  'wd.applied': 'Übernommen: {new} neue Rechnungen.',
  'wd.columns': 'Erkannte Spalten',
  'wd.col.number': 'Rechnungsnr.', 'wd.col.date': 'Datum', 'wd.col.project': 'Projekt', 'wd.col.customer': 'Kunde', 'wd.col.po': 'PO', 'wd.col.amount': 'Betrag', 'wd.col.status': 'Status',
  'wd.state.new': 'Neu', 'wd.state.differs': 'Weicht ab (bleibt)', 'wd.state.unchanged': 'Unverändert', 'wd.state.unmatched': 'Projekt fehlt',
  'wd.mapTitle': 'Projekte zuordnen',
  'wd.mapLead': 'Diese Workday-Projekte kennt das Tool noch nicht. Wähle das passende Projekt; die Zuordnung wird für die nächsten Importe gemerkt.',
  'wd.mapSkip': '– nicht übernehmen –',
  'wd.recheck': 'Mit Zuordnung neu prüfen',
  'wd.rows': 'Rechnungen',
  'wd.wdProject': 'Workday-Projekt',
  'wd.note.po_unknown': 'PO {po} gibt es im Tool nicht',
  'wd.note.no_date': 'ohne Datum',
  'wd.skipped': '{n} Zeilen übersprungen (storniert, Entwurf oder ohne Betrag)',
  'wd.showUnchanged': 'Unveränderte zeigen',
  'wd.nothing': 'Nichts zu übernehmen – alles ist schon im Tool.',

  // Import
  'imp.title': 'Daten aus Excel übernehmen',
  'imp.lead': 'Wähle die Orders-&-Invoices-Dateien der Jahre aus. Erst kommt ein Probelauf, der nichts speichert. Danach kannst du übernehmen. Ein erneuter Import ändert nur, was sich in der Excel geändert hat; gelöscht wird nichts.',
  'imp.drop': 'Excel-Dateien hierher ziehen oder <u>auswählen</u>',
  'imp.dry': 'Probelauf',
  'imp.checking': 'Prüfe …',
  'imp.apply': 'Übernehmen',
  'imp.applying': 'Übernehme …',
  'imp.applied': 'Übernommen',
  'imp.fixFirst': 'Erst die Fehler in der Excel beheben.',
  'imp.dryTitle': 'Probelauf: das würde passieren',
  'imp.result': 'Ergebnis',
  'imp.rows': '{y}: {n} Zeilen',
  'imp.col.area': 'Bereich',
  'imp.col.new': 'Neu',
  'imp.col.changed': 'Geändert',
  'imp.col.unchanged': 'Unverändert',
  'imp.findings': 'Auffälligkeiten ({n})',
  'imp.row': '{y} · Zeile {n}',
  'imp.more': ' und {n} weitere',
  'imp.level.error': 'Fehler',
  'imp.level.warn': 'Prüfen',
  'imp.level.info': 'Hinweis',
  'imp.c.customers': 'Kunden',
  'imp.c.projects': 'Projekte',
  'imp.c.targets': 'Jahresziele',
  'imp.c.orders': 'Bestellungen',
  'imp.c.orderLines': 'Bestellpositionen',
  'imp.c.invoices': 'Rechnungen',

  // Hilfe und Umgebung
  'nav.help': 'Hilfe',
  'help.title': 'Handbuch',
  'help.toc': 'Inhalt',
  'env.test': 'TESTUMGEBUNG – Änderungen hier wirken nicht auf die echten Daten.',
  'env.dev': 'LOKALE ENTWICKLUNG',
  'sync.title': 'Workday-Abgleich',
  'sync.never': 'Noch kein Abgleich mit Workday.',
  'sync.kind.auto': 'automatisch über {by}',
  'sync.kind.manual': 'Upload von {by}',
  'sync.new': '{n} neue Rechnung(en)',
  'sync.nothingNew': 'nichts Neues',
  'sync.unmatched': '{n} ohne Projekt-Zuordnung',
  'sync.differs': '{n} weichen ab (unverändert)',
  'sync.failed': 'abgebrochen',
  'sync.lastSuccess': 'Letzter erfolgreicher Abgleich: {at}',
  'sync.pending': 'Angefordert von {by} am {at}. Wird mit dem nächsten Lauf erledigt (stündlich, Mo–Fr 8–19 Uhr).',
  'sync.now': 'Jetzt synchronisieren',
  'sync.requesting': 'Fordere an …',
  'sync.requested': 'Angefordert',
  'sync.details': 'Details',
  'sync.hide': 'Weniger',
  'sync.newList': 'Neu dazugekommen ({n})',
  'sync.unmatchedList': 'Nicht übernommen, Projekt unbekannt ({n})',
  'sync.unmatchedHint': 'Einmal das Projekt zuordnen, dann übernimmt der nächste Lauf sie:',
  'sync.history': 'Letzte Abgleiche',
  'role.deliveryHead': 'Delivery Head',
  'area.viewOnly': 'nur ansehen',
  'area.viewOnlyOpt': '{name} (nur ansehen)',
  'area.viewOnlyHelp': 'Diesen Bereich siehst du als Delivery Head. Ändern können nur Personen, die dem Bereich zugeordnet sind.',
  'users.allAreas': 'alle Bereiche',
  'uf.dhAddon': 'Zusätzlich Delivery Head (alle Bereiche ansehen)',
  'uf.dhHelp': 'Delivery Head sieht alle Bereiche und die Gesamtübersicht. In Bereichen, denen die Person nicht zugeordnet ist, kann sie nur ansehen.',
  'dh.title': 'Alle Bereiche {y}',
  'dh.hint': 'Klick auf einen Bereich zeigt dessen Cockpit',
  'dh.areas': '{n} Bereiche',
  'dh.issues': '{u} dringend · {c} zu prüfen',
  'dh.col.risk': 'Projekte mit Risiko',
  'dh.urgent': '{n} dringend',
  'dh.check': '{n} prüfen',
  'dh.open': 'Öffnen →',
  'dh.current': 'gewählt',
  'dh.reachLabel': '{p} abgerechnet, Soll heute {pace}',
  'scan.title': 'Bestellordner',
  'scan.noFolders': 'Noch kein Projekt mit Bestellordner. Unter Verwaltung → Projekte & Zuständigkeiten den Ordner eintragen.',
  'scan.never': '{n} Ordner hinterlegt, noch nicht durchsucht.',
  'scan.pending': 'Angefordert von {by} am {at}. Wird mit dem nächsten Lauf erledigt (stündlich, Mo–Fr 8–19 Uhr).',
  'scan.now': 'Jetzt durchsuchen',
  'scan.folders': '{n} Ordner',
  'scan.scanned': '{n} PDFs geprüft',
  'scan.new': '{n} neue Bestellung(en)',
  'scan.dup': '{n} schon vorhanden',
  'scan.err': '{n} nicht lesbar',
  'inbox.title': 'Gefundene Bestellungen ({n})',
  'inbox.hint': 'Aus den Bestellordnern. Prüfen und anlegen oder verwerfen.',
  'inbox.col.file': 'Datei',
  'inbox.col.found': 'Erkannt',
  'inbox.unreadable': 'nicht lesbar',
  'inbox.exists': 'gibt es schon:',
  'inbox.check': 'bitte prüfen',
  'inbox.ready': 'vollständig erkannt',
  'inbox.manual': 'Von Hand anlegen',
  'inbox.review': 'Prüfen & anlegen',
  'inbox.attach': 'PDF anhängen',
  'inbox.attached': 'PDF an die Bestellung gehängt',
  'inbox.dismiss': 'Verwerfen',
  'inbox.dismissed': 'Fund verworfen',
  'inbox.reanalyze': 'Erkennung wiederholen',
  'inbox.reanalyzed': 'Funde neu erkannt',
  'pf.folder': 'Bestellordner',
  'pf.folderPh': 'https://smtsoftwareservices.sharepoint.com/…/02 - Purchase Orders',
  'pf.folderHelp': 'SharePoint-Link zum Ordner mit den Bestell-PDFs (in SharePoint: Ordner öffnen → „Link kopieren“ oder Adresse aus dem Browser) oder lokaler OneDrive-Pfad. Unterordner je Jahr/Quartal werden mit durchsucht; berücksichtigt werden PDFs ab 1.1. des laufenden Jahres (im 1. Quartal auch das Vorjahr).',
  'pf.folderTag': 'Bestellordner',
  'pf.workday': 'Workday-Projekt-ID',
  'pf.workdayHelp': 'z. B. PROJECT-13113. Verbindet Workday-Rechnungen und die Forecast-Datei (iFC) mit dem Projekt.',
  'pf.err.workday': 'Workday-Projekt-ID bitte im Format PROJECT-12345.',
  'tokens.title': 'API-Schlüssel',
  'tokens.lead': 'Für Skripte, die im Namen deiner Person auf das Tool zugreifen, z. B. den Bestellordner-Scan auf deinem Rechner. Der Schlüssel wird nur einmal angezeigt.',
  'tokens.add': 'Neuer Schlüssel',
  'tokens.name': 'Bezeichnung',
  'tokens.namePh': 'z. B. Bestellordner-Scan Laptop',
  'tokens.created': 'Angelegt',
  'tokens.used': 'Zuletzt benutzt',
  'tokens.never': 'noch nie',
  'tokens.revoke': 'Widerrufen',
  'tokens.copy': 'Diesen Schlüssel jetzt kopieren und sicher ablegen. Er wird nicht noch einmal angezeigt:',
  'auto.title': 'Browser-Automatisierung',
  'auto.lead': 'Für die geplanten Läufe in Chrome (Bestellordner-Scan, Forecast-Abgleich). Der Schlüssel liegt nur in deinem Chrome auf der SharePoint-Seite und kann ausschließlich Abgleiche starten – sonst nichts. Gültig 180 Tage; ein neuer Schlüssel ersetzt den alten.',
  'auto.none': 'Noch nicht eingerichtet.',
  'auto.active': 'Eingerichtet',
  'auto.expires': 'gültig bis',
  'auto.create': 'Einrichten',
  'auto.renew': 'Neu einrichten',
  'auto.revoke': 'Widerrufen',
  'auto.steps': 'So hinterlegst du den Schlüssel (einmalig, in dem Chrome, in dem die Automatisierung läuft):',
  'auto.step1': 'SharePoint öffnen (Link unten) und warten, bis die Seite geladen ist.',
  'auto.step2': 'F12 drücken → Reiter „Konsole“. Fragt Chrome nach „allow pasting“, das einmal eintippen und Enter.',
  'auto.step3': 'Die Zeile unten kopieren, in die Konsole einfügen, Enter. Dann F12 schließen.',
  'auto.copyLine': 'Zeile kopieren',
  'auto.copied': 'Kopiert',
  'auto.openSp': 'SharePoint öffnen',
  'auto.once': 'Die Zeile enthält den Schlüssel und wird nur jetzt angezeigt.',
  'admin.tab.tokens': 'API-Schlüssel',
  'fc.title': "Forecast",
  'search.title': "Suche",
  'search.button': "Suchen",
  'search.placeholder': "Bestellnummer, Rechnung, Projekt, Kunde oder Seite …",
  'search.hint': "Mindestens 2 Zeichen eingeben – oder eine Seite / Ansicht wählen.",
  'search.none': "Nichts gefunden.",
  'search.type.order': "Bestellungen",
  'search.type.contract': "Verträge",
  'search.type.invoice': "Rechnungen",
  'search.type.project': "Projekte",
  'search.type.customer': "Kunden",
  'search.views': "Gespeicherte Ansichten",
  'search.pages': "Seiten",
  'search.move': "auswählen",
  'search.open': "öffnen",
  'keys.title': "Tastenkürzel",
  'keys.ctrl': "Strg",
  'keys.search': "Suche öffnen",
  'keys.new': "Neu anlegen (Bestellungen, Verträge, Invoicing)",
  'keys.goStart': "Zur Startseite",
  'keys.goOrders': "Zu Bestellungen",
  'keys.goProjects': "Zu Projekte",
  'keys.goInvoicing': "Zu Invoicing",
  'keys.goForecast': "Zu Forecast",
  'keys.goIssues': "Zu Offene Punkte",
  'keys.help': "Diese Übersicht",
  'keys.thenHint': "„G“ und danach den Buchstaben drücken.",
  'views.button': "Ansichten",
  'views.saveCurrent': "Aktuelle Filter speichern als",
  'views.namePh': "z. B. Meine BMW-Bestellungen",
  'views.empty': "Noch keine gespeicherten Ansichten.",
  'views.delete': "Ansicht {n} löschen",
  'views.page.bestellungen': "Bestellungen",
  'views.page.invoicing': "Invoicing",
  'views.page.projekte': "Projekte",
  'views.page.forecast': "Forecast",
  'views.page.offene-punkte': "Offene Punkte",
  'tour.label': "Einführung",
  'tour.skip': "Überspringen",
  'tour.back': "Zurück",
  'tour.next': "Weiter",
  'tour.finish': "Los geht’s",
  'tour.restart': "Einführung starten",
  'tour.1.t': "Willkommen im Financial Tool",
  'tour.1.d': "Hier laufen Bestellungen, Rechnungen, Ziele und Forecast deines Bereichs zusammen. Die Startseite zeigt die wichtigsten Zahlen und was gerade zu tun ist – umschaltbar zwischen „Alle“ und „Meine Projekte“.",
  'tour.2.t': "Bestellungen",
  'tour.2.d': "Neue Bestellungen legst du von Hand oder aus der PDF an. Oben siehst du „Gefundene Bestellungen“ aus den SharePoint-Ordnern der Projekte – prüfen, anlegen, fertig.",
  'tour.3.t': "Invoicing",
  'tour.3.d': "Rechnungen kommen automatisch aus Workday. Mit „Jetzt synchronisieren“ holst du den neuesten Stand; Rechnungen ohne Bestellung erscheinen unter Offene Punkte.",
  'tour.4.t': "Forecast",
  'tour.4.d': "Der Forecast kommt aus den Firmen-Forecast-Dateien. Du siehst je Account und Monat Forecast und Ist – und was noch nicht bestellt ist.",
  'tour.5.t': "Schneller ans Ziel",
  'tour.5.d': "Mit Strg+K (Mac: ⌘K) oder „/“ findest du jede Bestellung, Rechnung und jedes Projekt. „?“ zeigt alle Tastenkürzel. Lieblingsfilter speicherst du über „Ansichten“. Hilfe und Handbuch findest du links unten.",
  'fc.kpi.uncovered': "Noch nicht bestellt",
  'fc.kpi.uncoveredSub': "Forecast bis Jahresende {rest}, offenes Bestellvolumen {open}",
  'fc.col.uncovered': "Nicht bestellt",
  'fc.col.uncoveredHelp': "Forecast ab dem laufenden Monat, der nicht durch offenes Bestellvolumen gedeckt ist",
  'fc.chartView': "Diagrammansicht",
  'fc.keyForecast': "Forecast (Excel)",
  'fc.keyActual': "Ist (Rechnungen)",
  'fc.keyOpen': "noch nicht beauftragt",
  'fc.kpi.actualOf': "{p} des Forecasts erreicht",
  'fc.kpi.accounts': "Forecast je Account",
  'fc.chartHint': "Forecast je Account gestapelt, Strich = Ist. Accounts per Klick ein- und ausblenden.",
  'fc.legendLabel': "Accounts im Diagramm",
  'fc.accounts': "{n} Accounts · {p} Projekte",
  'fc.expandAll': "Alle aufklappen",
  'fc.collapseAll': "Alle zuklappen",
  'fc.col.account': "Account / Projekt",
  'fc.nProjects': "{n} Projekte",
  'fc.oneProject': "1 Projekt",
  'fc.logoAdd': "Logo hinzufügen",
  'fc.logoChange': "Logo ändern",
  'fc.logoSaved': "Logo gespeichert",
  'fc.kpi.forecast': "Forecast {y}",
  'fc.kpi.ofTarget': "{p} des Jahresziels ({target})",
  'fc.kpi.fromFiles': "aus den Forecast-Dateien",
  'fc.kpi.actual': "Abgerechnet",
  'fc.kpi.actualSub': "laut Rechnungen im Tool",
  'fc.kpi.expected': "Erwartung Jahresende",
  'fc.kpi.gap': "Abstand zum Ziel: {v}",
  'fc.kpi.expectedSub': "Ist bis Vormonat + Forecast ab jetzt",
  'fc.chart': "Umsatz je Monat {y}",
  'fc.legend.actual': "Ist (Rechnungen)",
  'fc.legend.forecast': "Forecast",
  'fc.count': "{n} Projekte",
  'fc.tableHint': "Oben Forecast, darunter Ist. Kursiv: noch nicht beauftragt.",
  'fc.showAll': "auch Projekte ohne Forecast",
  'fc.empty': "Noch kein Forecast. Workday-Projekt-ID am Projekt eintragen und synchronisieren.",
  'fc.col.forecast': "Forecast",
  'fc.col.actual': "Ist",
  'fc.col.expected': "Erwartung",
  'fc.col.target': "Ziel",
  'fc.sumForecast': "Summe Forecast",
  'fc.sumActual': "Summe Ist",
  'fc.noWorkdayId': "Workday-Projekt-ID fehlt (Verwaltung → Projekte)",
  'fc.notContracted': "noch nicht beauftragt",
  'fc.help': "Quelle: Forecast-Dateien iFC_PROJECT-#####_….xlsx in SharePoint „Project Delivery“ (Dashboards/Forecast), zugeordnet über die Workday-Projekt-ID. Übernommen werden nur die Monate {y}; bei jedem Abgleich werden sie ersetzt. Ist = Rechnungen nach Rechnungsdatum.",
  'fc.sync.title': "Abgleich mit den Forecast-Dateien",
  'fc.sync.never': "Noch kein Abgleich.",
  'fc.sync.last': "Zuletzt {at} ({by})",
  'fc.sync.files': "{n} Projekte übernommen",
  'fc.sync.unmatched': "{n} nicht zugeordnet",
  'fc.sync.failed': "Abgleich am {at} abgebrochen: {msg}",
  'fc.upload': "Datei hochladen",
  'fc.uploaded': "{ok} Datei(en) übernommen, {bad} nicht zugeordnet.",
  'fc.reason.unmatched': "kein Projekt mit Workday-ID {id}",
  'fc.reason.empty': "keine Werte für {y}",
  // Sichtbare Seiten (Rolle „lesend“)
  "section.orders": "Bestellungen",
  "section.projects": "Projekte & Ziele",
  "section.invoicing": "Invoicing (Rechnungen)",
  "section.forecast": "Forecast",
  "section.issues": "Offene Punkte",
  "uf.sections": "Sichtbare Seiten",
  "uf.sectionsHelp": "Nur bei „Lesend“. Startseite (nur Kennzahlen) und Hilfe sieht jeder. Nicht freigeschaltete Seiten verschwinden aus dem Menü und sind auch über Links und Export gesperrt.",
  "uf.err.sections": "Bitte mindestens eine Seite freischalten.",
  "sections.forbidden.title": "Nicht freigeschaltet",
  "sections.forbidden.text": "Diese Seite ist für dich nicht freigeschaltet. Wende dich bei Bedarf an einen Admin.",
  // Löschen
  "del.withInvoices": "Löschen – {n} Rechnung(en) bleiben ohne Bestellung erhalten",
  "del.hasAmendments": "Erst die Nachträge löschen oder lösen",
  "del.row": "{n} löschen",
  "del.short": "Löschen? Rechnungen bleiben",
  "del.done": "Gelöscht",
  "del.notAllowed": "Löschen dürfen nur PM oder Vertretung des Projekts, Admins und Delivery Heads",
  // Angebote, Nachträge, PM-Prüfung
  "pdf.warn.unsigned": "Keine Unterschrift im Abschnitt Auftragsbestätigung gefunden – ist das Angebot wirklich beauftragt?",
  "pdf.warn.monthly": "Monatlicher Rahmen ohne Gesamtbetrag (ca. {monthly} pro Monat) – Volumen bitte festlegen, z. B. Monate × Monatsbetrag",
  "pdf.warn.parentMissing": "Die ursprüngliche Bestellung {parent} gibt es im Tool noch nicht – bitte zuerst anlegen, dann den Nachtrag zuordnen",
  "pdf.doc.offer": "Unterschriebenes Angebot (Auftragsbestätigung)",
  "pdf.doc.changeRequest": "Change Request – Nachtrag zu {parent}",
  "pdf.ocr": "Text per Texterkennung aus einem Scan gelesen – Zahlen besonders genau prüfen.",
  "pdf.checked": "Ich habe alle Werte mit der PDF abgeglichen.",
  "pdf.checkedHint": "Pflicht beim Anlegen aus dem Posteingang. Wird an der Bestellung mit Name und Zeit vermerkt.",
  "of.err.checked": "Bitte bestätigen, dass du die Werte mit der PDF abgeglichen hast.",
  "of.parent": "Nachtrag zu",
  "of.parentNone": "– keine (eigenständige Bestellung) –",
  "of.parentHint": "Für Change Requests und Aufstockungen: nur den zusätzlichen Betrag eintragen. Status und Verbrauch werden über Bestellung und Nachträge gemeinsam berechnet.",
  "order.amendmentOf": "Nachtrag zu",
  "order.amendments": "Nachträge ({n})",
  "order.amendmentsHint": "Status und Verbrauch gelten für Bestellung und Nachträge zusammen",
  "order.groupTotal": "Gesamt inkl. Nachträge",
  "order.thisOrder": "Diese Bestellung",
  "order.checkedBy": "Mit PDF geprüft von {name} am {at}",
  "order.notChecked": "Noch nicht gegen die PDF geprüft",
  "order.confirmCheck": "Prüfung bestätigen",
  "order.confirmed": "Prüfung vermerkt",
  "orders.amendment": "Nachtrag",
  "orders.withAmendments": "gesamt inkl. Nachträgen: {total}",
  "inbox.ocrPending": "wird gelesen (Texterkennung) …",
  "inbox.ocrFailed": "Texterkennung fehlgeschlagen",
  "inbox.unsigned": "nicht unterschrieben",
  "inbox.offer": "Angebot",
  "inbox.cr": "Nachtrag zu {parent}",
  "inbox.pmOnly": "Prüfung durch PM/Vertretung des Projekts oder wer hochgeladen hat",
  "issue.inboxReview.t": "Bestell-PDFs warten auf deine Prüfung: {n}",
  "issue.inboxReview.d": "Hochgeladen von dir oder für dein Projekt gefunden. Unter Bestellungen nacheinander prüfen und anlegen.",
  "pz.emptyHint": "noch keine Bestellung",
  "up.title": "Bestell-PDFs hochladen",
  "up.drop": "PDFs hierher ziehen oder klicken und mehrere auswählen",
  "up.project": "Für Projekt",
  "up.projectPick": "Projekt wählen …",
  "up.projectHelp": "Für dieses Projekt werden die PDFs geprüft. Prüfen können du und PM/Vertretung des Projekts.",
  "up.needProject": "Bitte zuerst das Projekt wählen.",
  "up.notPdf": "{file}: keine PDF, übersprungen",
  "up.busy": "Lade hoch: {i} von {n} …",
  "up.done": "{n} hochgeladen",
  "up.known": "{n} schon bekannt",
  "up.reading": "{n} eingescannt, Texterkennung läuft",
  "up.failed": "{n} fehlgeschlagen",
  "up.button": "PDFs hochladen",
  "inbox.hintAll": "Aus den Bestellordnern oder hochgeladen. Nacheinander prüfen und anlegen oder verwerfen.",
  "inbox.startQueue": "Nacheinander prüfen ({n})",
  "inbox.showAll": "Alle offenen anzeigen ({n})",
  "inbox.showMine": "Nur meine",
  "inbox.others": "{n} weitere offene Funde anderer Projekte",
  "inbox.uploadedBy": "hochgeladen von {name}",
  "inbox.scanned": "aus Bestellordner",
  "queue.pos": "{i} von {n}",
  "queue.skip": "Überspringen",
  "queue.done": "Alle Bestell-PDFs geprüft",
  "field.checked_by": "Geprüft von",
  "nav.contracts": "Verträge",
  "keys.goContracts": "Zu Verträge",
  "section.contracts": "Verträge",
  "pz.noContract": "kein Vertrag",
  "ct.title": "Verträge",
  "ct.lead": "Hauptverträge (Rahmenverträge) mit Budget – für alle Bereiche. Jeder Bereich ordnet seine Projekte zu; ihre Bestellungen zählen automatisch darauf. So siehst du, ob der Vertrag noch weitere Bestellungen hergibt.",
  "ct.new": "Neuer Vertrag",
  "ct.searchPh": "Vertrag, Nummer, Projekt …",
  "ct.state.noBudget": "ohne Budget",
  "ct.state.ok": "Budget frei",
  "ct.state.nearlyUsed": "fast aufgebraucht",
  "ct.state.exceeded": "überschritten",
  "ct.expired": "abgelaufen",
  "ct.endsIn": "endet in {n} Tagen",
  "ct.filterEnding": "läuft bald aus",
  "ct.filterNotFiled": "Ablage fehlt",
  "ct.empty": "Noch keine Verträge. Mit „Neuer Vertrag“ anlegen – Werte von Hand oder aus der Vertrags-PDF.",
  "ct.emptyFilter": "Keine Verträge für diese Auswahl.",
  "ct.col.contract": "Vertrag",
  "ct.col.projects": "Projekte",
  "ct.col.term": "Laufzeit",
  "ct.col.budget": "Budget",
  "ct.col.ordered": "Bestellt",
  "ct.col.rest": "Noch frei",
  "ct.col.usage": "Verbrauch",
  "ct.col.filed": "Ablage",
  "ct.col.billed": "Abgerechnet",
  "ct.col.share": "Anteil",
  "ct.col.counts": "Zählt auf Vertrag",
  "ct.col.year": "Jahr",
  "ct.col.yearBudget": "Jahresbudget",
  "ct.noProjects": "noch keine Projekte",
  "ct.filed": "abgelegt",
  "ct.notFiled": "Ablage fehlt",
  "ct.notFiledHint": "SharePoint-Link oder PDF des Vertrags fehlt",
  "ct.missingLink": "SharePoint-Link fehlt",
  "ct.missingPdf": "PDF fehlt",
  "ct.and": " und ",
  "ct.freeTitle": "Projekte ohne Vertrag ({n})",
  "ct.freeHint": "Diese Projekte gehören zu keinem Hauptvertrag.",
  "ct.freeShow": "Anzeigen",
  "ct.kind": "Hauptvertrag",
  "ct.budgetDerived": "aus Projekt-Anteilen bzw. Jahresbudgets",
  "ct.usedOf": "{p} des Budgets",
  "ct.restHint": "für weitere Bestellungen",
  "ct.billedHint": "nur zur Info",
  "ct.filedOk": "Sauber abgelegt: SharePoint-Link und PDF sind hinterlegt.",
  "ct.filedMissing": "Nicht vollständig abgelegt: {what}. Bitte unter „Bearbeiten“ bzw. „PDF hochladen“ ergänzen.",
  "ct.projectsHint": "Ihre Bestellungen zählen automatisch auf diesen Vertrag",
  "ct.ordersTitle": "Bestellungen auf diesem Vertrag ({n})",
  "ct.ordersHint": "nur die Positionen der Vertragsprojekte",
  "ct.noOrders": "Noch keine Bestellungen.",
  "ct.yearsTitle": "Je Jahr",
  "ct.yearsHint": "Jahresbudgets sind optional (unter „Bearbeiten“)",
  "ct.docs": "Ablage",
  "ct.openSharepoint": "In SharePoint öffnen",
  "ct.pdf": "Vertrags-PDF",
  "ct.histWhat": "Vertrag",
  "ct.saved": "Vertrag gespeichert",
  "cf.manualOrdered": "Bestellt von Hand",
  "cf.manualBilled": "Abgerechnet von Hand",
  "cf.lineManualOrdered": "Bestellt von Hand Jahr {n} in Euro",
  "cf.lineManualBilled": "Abgerechnet von Hand Jahr {n} in Euro",
  "cf.manualSum": "Summe von Hand",
  "ct.manual": "von Hand",
  "ct.manualHint": "Wert von Hand (Altverbrauch)",
  "ct.manualConflict": "Im Tool gibt es für {year} auch Bestellungen über {sum} – es zählt der Wert von Hand.",
  "ct.manualIncl": "davon {sum} von Hand (Altverbrauch)",
  "ct.col.areas": "Bereiche",
  "ct.col.area": "Bereich",
  "ct.areasTitle": "Bereiche",
  "ct.areasHint": "Wer auf diesen Vertrag bestellt",
  "ct.homeArea": "angelegt in {area}",
  "ct.extTitle": "Abrufe anderer intive-Bereiche",
  "ct.extHint": "Bereiche ohne Financial Tool – von Hand eingetragen, zählen auf „Bestellt“",
  "ct.extRow": "andere intive-Bereiche",
  "ct.extMore": "+ andere intive-Bereiche",
  "ct.hiddenOrders": "Dazu {n} Bestellungen aus {area} ({sum}). Einzeln sehen sie die Personen dort sowie Admins und Delivery Heads.",
  "ct.assign": "Projekte zuordnen",
  "cf.assign": "Projekte aus {area} zu {name} zuordnen",
  "cf.headLocked": "Bezeichnung, Laufzeit, Budget, Ablage und Abrufe ändern nur wer den Vertrag angelegt hat, Admins und Delivery Heads. Du kannst die Projekte deines Bereichs zuordnen.",
  "cf.otherProjects": "Projekte anderer Bereiche (ordnen deren PMs zu): {list}",
  "cf.customerHome": "Kunde aus dem Bereich {area}, in dem der Vertrag angelegt wurde.",
  "cf.ext": "Abrufe anderer intive-Bereiche",
  "cf.extHelp": "Für intive-Bereiche, die das Tool nicht nutzen: Bereich, Betrag, Datum (optional), Notiz. Zählt auf „Bestellt“. Kommt der Bereich später ins Tool, ordnet er seine Projekte zu und der Eintrag wird hier gelöscht.",
  "cf.extArea": "Bereich Abruf {n}",
  "cf.extAmount": "Betrag Abruf {n} in Euro",
  "cf.extDate": "Datum Abruf {n}",
  "cf.extNote": "Notiz Abruf {n}",
  "cf.extAreaPh": "z. B. intive Polen",
  "cf.extNotePh": "Notiz (optional)",
  "cf.addExt": "+ Abruf",
  "cf.extSum": "Summe Abrufe",
  "cf.err.ext": "Bei jedem Abruf bitte Bereich und Betrag eintragen.",
  "cf.new": "Neuer Vertrag",
  "cf.edit": "Vertrag {name} bearbeiten",
  "cf.drop": "Vertrags-PDF hierher ziehen oder klicken – Nummer, Kunde, Laufzeit und Volumen werden vorgeschlagen (auch bei Scans)",
  "cf.reading": "PDF wird gelesen … (bei Scans per Texterkennung, das kann eine Minute dauern)",
  "cf.pdfChosen": "{file} – wird beim Speichern abgelegt. Andere PDF hierher ziehen zum Ersetzen.",
  "cf.pdfReplace": "Abgelegt: {file}. Neue PDF hierher ziehen zum Ersetzen.",
  "cf.pdfCheck": "Werte aus der PDF übernommen – bitte prüfen.",
  "cf.pdfNoBudget": "Kein Volumen erkannt – bitte von Hand eintragen.",
  "cf.name": "Bezeichnung",
  "cf.namePh": "z. B. BMW Rahmenvertrag Software 2026–2027",
  "cf.number": "Vertragsnummer",
  "cf.from": "Gültig ab",
  "cf.to": "Gültig bis",
  "cf.budget": "Gesamtbudget (€)",
  "cf.budgetHelp": "Optional. Leer = Summe der Projekt-Anteile bzw. der Jahresbudgets.",
  "cf.projects": "Projekte",
  "cf.projectsHelp": "Projekte aus {area}: Alle Bestellungen dieser Projekte zählen automatisch auf den Vertrag. Anteil je Projekt ist optional.",
  "cf.lineProject": "Projekt {n}",
  "cf.lineShare": "Anteil Projekt {n} in Euro",
  "cf.sharePh": "Anteil (optional)",
  "cf.lineRemove": "Zeile {n} entfernen",
  "cf.shareSum": "Summe Anteile",
  "cf.shareDiff": "Die Anteile ({sum}) ergeben nicht das Gesamtbudget ({budget}).",
  "cf.years": "Budget je Jahr",
  "cf.yearsHelp": "Optional: Budget je Vertragsjahr. Für Jahre, deren Bestellungen und Rechnungen nicht im Tool sind (z. B. vor 2026), trägst du hier bestellt bzw. abgerechnet von Hand ein – das ersetzt für dieses Jahr die Werte aus dem Tool.",
  "cf.lineYear": "Jahr {n}",
  "cf.lineYearBudget": "Budget Jahr {n} in Euro",
  "cf.addYear": "+ Jahr",
  "cf.yearSum": "Summe Jahre",
  "cf.link": "SharePoint-Link",
  "cf.linkHelp": "Link zum Vertrag bzw. Vertragsordner in SharePoint (in SharePoint: „Link kopieren“).",
  "cf.err.name": "Bitte eine Bezeichnung eingeben.",
  "cf.err.customer": "Bitte den Kunden wählen.",
  "cf.err.amount": "Ein Betrag oder Jahr ist nicht lesbar.",
  "cf.err.link": "Der SharePoint-Link muss mit https:// beginnen.",
  "of.contractRest": "Zählt auf Vertrag {name} – danach noch {rest} frei.",
  "of.contractOver": "Zählt auf Vertrag {name} – überschreitet das Budget um {over}.",
  "of.contractNoBudget": "Zählt auf Vertrag {name} (ohne Budget).",
  "of.contractShareOver": "Anteil {project} wird um {over} überschritten.",
  "issue.contractExceeded.t": "Vertrag {contract} überschritten",
  "issue.contractExceeded.d": "Bestellt {ordered} bei Budget {budget} – {over} darüber. Nachtrag zum Vertrag klären.",
  "issue.contractNearlyUsed.t": "Vertrag {contract} fast aufgebraucht",
  "issue.contractNearlyUsed.d": "Bestellt {ordered} von {budget}. Verlängerung oder Aufstockung rechtzeitig anfragen.",
  "issue.contractShareExceeded.t": "Vertrag {contract}: Anteil {project} überschritten",
  "issue.contractShareExceeded.d": "Bestellt {ordered} bei Anteil {budget}.",
  "issue.contractEnding.t": "Vertrag {contract} endet in {days} Tagen",
  "issue.contractEnding.d": "Laufzeit bis {date}. Anschlussvertrag klären.",
  "issue.contractNotFiled.t": "Vertrag {contract} nicht vollständig abgelegt",
  "issue.contractNotFiled.d": "{missing}. Bitte am Vertrag ergänzen.",
  "if.payStatus": "Zahlungsstatus",
  "if.payHelp": "Kommt normalerweise aus dem Workday-Abgleich. Hier kannst du ihn von Hand setzen, z. B. wenn die Rechnung nicht in Workday liegt oder die Zahlung bekannt ist.",
  "if.paySetManual": "Von Hand gesetzt am {at}. Der Workday-Abgleich stellt nur noch auf „bezahlt“ um, nie zurück auf „offen“.",
  "if.paySetWorkday": "Aus dem Workday-Abgleich vom {at}. Änderst du ihn hier, gilt dein Wert; Workday stellt nur noch auf „bezahlt“ um.",
  "if.dueDate": "Fällig am",
  "if.dueHelp": "Optional; ab diesem Tag zählt die Rechnung als überfällig.",
  "if.warranty": "Warranty-Rechnung",
  "if.warrantyHelp": "Zählt als Umsatz (Forecast, Abgerechnet), aber nicht als Forderung: nicht in offen, überfällig oder bezahlt und nicht gegen das Volumen einer normalen Bestellung.",
  "pay.warranty": "Warranty",
  "pay.warrantyHint": "Warranty: zählt als Umsatz, nicht als Forderung",
  "pay.manual": "von Hand gesetzt",
  "if.paidAt": "Bezahlt am",
  "if.paidAtHelp": "Zahlungseingang; vorbelegt mit heute.",
  "if.err.paidAt": "Bitte „Bezahlt am“ angeben.",
  "pay.paidOn": "bezahlt am {date}",
  "pay.kpiPaid": "Bezahlt",
  "pay.kpiPaidShare": "{p} vom Abgerechneten",
  "fg.title": "Forecast gegen Rechnungen {y}",
  "fg.hint": "Forecast von Januar bis einschließlich des gezählten Monats gegen alle Rechnungen des Jahres. Der laufende Monat zählt erst ab seinem letzten Arbeitstag (dann ist sein Umsatz zur Rechnung geplant). Kunden- und Projektfilter gelten mit; Projekte ohne Forecast fehlen.",
  "fg.forecastToDate": "Forecast {r}",
  "fg.billed": "Abgerechnet {y}",
  "fg.gap": "Noch zu fakturieren",
  "fg.ahead": "Voraus",
  "fg.gapSub": "bis Ende {m}",
  "fg.aheadSub": "mehr abgerechnet als bisher im Forecast",
  "fg.year": "Forecast Gesamtjahr",
  "fg.rest": "Rest bis Jahresende",
  "fg.restSub": "Gesamtjahr − Abgerechnet",
  "fg.col.forecast": "Forecast {r}",
  "fg.col.billed": "Abgerechnet",
  "fg.col.gap": "Noch zu stellen",
  "fg.col.rest": "Bis Jahresende",
  "pay.oldest": "älteste {n} Tage",
  "pay.agingTitle": "Offen nach Tagen seit Fälligkeit",
  "fg.asOf": "Stand {m}",
  "fg.fromFile": "laut Forecast-Datei",
  "pay.openNet": "offen {v} netto",
  "fg.nextFrom": "{m} ab {d}",
  "fg.noMonth": "noch kein Monat",
  "fg.gapNone": "noch kein Monat fällig",
  "out.title": "Ausstehend",
  "out.hint": "Was noch reinkommen muss: offene Rechnungen (gestellt, nicht bezahlt, netto) plus was laut Forecast bis zum gezählten Monat noch in Rechnung zu stellen ist. Kunden- und Projektfilter gelten mit.",
  "out.open": "Offen (nicht bezahlt)",
  "out.openSub": "{n} Rechnungen, netto",
  "out.toInvoice": "Noch zu fakturieren",
  "out.toInvoiceSub": "Forecast {r} − Abgerechnet",
  "out.total": "Ausstehend gesamt",
  "out.totalSub": "offen + noch zu fakturieren",
  "out.col.open": "Offen",
  "out.col.toInvoice": "Noch zu fakturieren",
  "out.col.total": "Ausstehend",
  "out.sum": "Summe",
  "fc.col.file": "Forecast-Datei",
  "fc.unit": "Einheit der Monatswerte",
  "fc.unitK": "Monatswerte in Tausend Euro",
  "fc.unitEur": "Monatswerte in Euro",
  "fc.file.open": "Forecast-Datei von {n} in SharePoint öffnen",
  "fc.file.modified": "geändert {d}",
  "fc.file.auto": "Link aus dem Forecast-Abgleich",
  "fc.file.manual": "Link von Hand gesetzt (Verwaltung → Projekte)",
  "fc.file.missing": "Link fehlt",
  "fc.file.missingHelp": "Keine Forecast-Datei bekannt. Kommt mit dem nächsten Abgleich oder von Hand unter Verwaltung → Projekte & Zuständigkeiten.",
  "pf.fcFile": "Forecast-Datei (Link)",
  "pf.fcFileAuto": "automatisch: {n}",
  "pf.fcFileHelp": "Leer lassen: Link kommt aus dem Forecast-Abgleich. Eigenen SharePoint-Link (https) einfügen, um ihn zu überschreiben.",
  "pf.err.fcFile": "Bitte einen Link mit https:// eingeben.",
  "pay.col": "Zahlung",
  "pay.filter": "Zahlung",
  "pay.paid": "bezahlt",
  "pay.unpaid": "offen",
  "pay.overdue": "überfällig",
  "pay.unknown": "nicht abgeglichen",
  "pay.overdueDays": "{n} Tage überfällig",
  "pay.openDays": "offen seit {n} Tagen",
  "pay.dueOn": "fällig am {date}",
  "pay.boxTitle": "Zahlungsstand",
  "pay.boxHint": "Alle Beträge netto. Offen = Nettobetrag der Rechnung; bei Teilzahlung der in Workday offene Betrag ohne 19 % USt. Kunden- und Projektfilter gelten mit.",
  "pay.kpiUnpaid": "Offen",
  "pay.kpiOverdue": "davon überfällig",
  "pay.kpiCount": "{n} Rechnungen",
  "pay.age.notDue": "nicht fällig",
  "pay.age.d30": "1–30 Tage",
  "pay.age.d60": "31–60 Tage",
  "pay.age.d90": "61–90 Tage",
  "pay.age.more": "über 90 Tage",
  "pay.showOverdue": "Überfällige anzeigen",
  "pay.unknownHint": "{n} Rechnungen noch ohne Zahlungsstatus aus Workday",
  "issue.invoiceOverdue.t": "Rechnung {invoice} seit {days} Tagen überfällig",
  "issue.invoiceOverdue.d": "{project}: {due} offen, fällig seit {date}. Beim Kunden nachfassen.",
  "nav.report": "Report",
  "rp.title": "Financial Report",
  "rp.lead": "Bericht zusammenklicken: Bereiche und Projekte wählen, Themen anhaken, Vorschau prüfen und als PowerPoint im intive-Layout herunterladen.",
  "rp.scope": "Auswahl",
  "rp.areas": "Bereiche",
  "rp.projects": "Projekte",
  "rp.allProjects": "Alle Projekte der Bereiche",
  "rp.ownProjects": "Du siehst nur deine Projekte (PM oder Vertretung).",
  "rp.compare": "Vergleich",
  "rp.compare.month": "mit Vormonat",
  "rp.compare.quarter": "mit Ende Vorquartal",
  "rp.compare.none": "ohne Vergleich",
  "rp.topics": "Themen",
  "rp.all": "Alles",
  "rp.none": "Nichts",
  "rp.reportTitle": "Titel (optional)",
  "rp.comment": "Kommentar (eigene Folie)",
  "rp.commentPh": "Einschätzung, Risiken, nächste Schritte …",
  "rp.topic.overview": "Überblick",
  "rp.topic.forecast": "Forecast",
  "rp.topic.projects": "Projektstatus",
  "rp.topic.contracts": "Verträge",
  "rp.topic.orders": "Bestellungen",
  "rp.topic.invoices": "Rechnungen",
  "rp.topic.issues": "Offene Punkte",
  "rp.topic.comment": "Kommentar",
  "rp.preview": "Vorschau",
  "rp.refresh": "Vorschau aktualisieren",
  "rp.pptx": "PowerPoint erstellen",
  "rp.creating": "PowerPoint wird erstellt …",
  "rp.created": "PowerPoint heruntergeladen",
  "rp.noArea": "Bitte mindestens einen Bereich wählen.",
  "rp.noTopic": "Bitte mindestens ein Thema wählen.",
  "rp.noProjects": "Keine Projekte zur Auswahl.",
  "rp.cmpFound": "Vergleich mit {month}",
  "rp.cmpMissing": "Für {month} gibt es noch keinen Monatsstand – Vergleich ab dem nächsten Monat.",
  "rp.kpi": "Kennzahl",
  "rp.now": "Aktuell",
  "rp.prev": "Vergleich",
  "rp.delta": "Δ",
  "rp.changes": "Änderungen",
  "rp.noChanges": "Keine wesentlichen Änderungen.",
  "rp.k.target": "Ziel",
  "rp.k.ordered": "Bestellt",
  "rp.k.billed": "Abgerechnet",
  "rp.k.forecast": "Forecast",
  "rp.k.expected": "Erwartung (Ist + Forecast)",
  "rp.k.uncovered": "Forecast ohne Bestellung",
  "rp.k.unpaid": "Rechnungen offen",
  "rp.k.overdue": "davon überfällig",
  "rp.k.urgent": "Dringende Punkte",
  "rp.k.crit": "Kritische Punkte",
  "rp.slide": "Folie {n}",
  "rp.openOrders": "Offenes Bestellvolumen {sum}",
  "rp.endingOrders": "Laufzeit endet in den nächsten 90 Tagen",
  "rp.noEnding": "Keine Bestellung endet in den nächsten 90 Tagen.",
  "rp.noContracts": "Keine Verträge zu den gewählten Projekten.",
  "rp.unpaidHead": "Offen {sum} · überfällig {over}",
  "rp.noUnpaid": "Keine offenen Rechnungen laut Workday.",
  "rp.noIssues": "Keine offenen Punkte.",
  "rp.days": "{n} Tage",
  "rp.endsOn": "endet {date}",
  "rp.forbidden": "Berichte erstellen PMs, Admins und Delivery Heads.",
  "rp.prevHealth": "vorher {h}",
  "rp.langNote": "Inhalte des Berichts sind auf Deutsch.",
  "cf.newCustomer": "+ Neuer Kunde …",
  "cf.newCustomerName": "Name des neuen Kunden",
  "cf.newCustomerPh": "z. B. BMW AG",
  "cf.newCustomerHelp": "Wird mit dem Vertrag im aktuellen Bereich angelegt. Projekte dazu legst du unter Verwaltung → Projekte an.",
  "cf.noCustomers": "In diesem Bereich gibt es noch keine Kunden – „+ Neuer Kunde“ wählen.",
  "field.parent_order_id": "Nachtrag zu",
  "mg.costImport": "Kostendaten einlesen",
  "mg.ci.title": "Kostendaten einlesen (Power BI „Project Cost Details“)",
  "mg.ci.lead": "In Power BI die Tabelle „Project Cost Details“ (project, Heading 2, Cat_Level_2, Cat_Level_3, Category_Object, Calendar_Period, Project Costs) als Excel exportieren und hier hochladen. Übernommen werden nur Projekte, die im Tool sind; andere (z. B. Akquise) werden übersprungen.",
  "mg.ci.range": "Export: {from} bis {to} · {n} Projekte im Tool",
  "mg.ci.semantics": "Je Projekt und Monat im Export werden alle Kostenposten ersetzt; Monate, die im Export fehlen, bleiben stehen. Status = Projekt-Monate.",
  "mg.ci.applied": "Übernommen: {n} Projekte",
  "mg.ci.monthsChanged": "{n} von {all} Monaten neu oder geändert",
  "mg.ci.notInTool": "nicht im Tool, übersprungen",
  "mg.ci.last": "Kostendaten · letzter Import",
  "mg.ci.lastLine": "{at} von {by} ({file}) · {from} bis {to}",
  "mg.ci.taken": "{n} Projekte übernommen",
  "mg.ci.skippedN": "{n} übersprungen – nicht im Tool",
  "mg.ci.skippedList": "Übersprungen: {list} (zusammen {sum})",
  "mg.col.mix": "Kostenmix",
  "mg.col.what": "Was ist passiert? ({m})",
  "mg.mix.personnel": "Personal",
  "mg.mix.subcontracting": "Sub",
  "mg.mix.other": "Sonst.",
  "mg.noCostData": "ohne Kostendaten",
  "mg.deepDive": "Projekt-Deep-Dive öffnen",
  "mg.deepDiveBtn": "Deep Dive →",
  "mg.deepDiveOf": "Deep Dive {p}",
  "pa.title": "Projekt-Deep-Dive",
  "pa.customer": "Kunde",
  "pa.pm": "PM",
  "pa.deputy": "Vertretung",
  "pa.target.project": "Projekt",
  "pa.target.area": "Bereich",
  "pa.target.default": "Standard",
  "pa.source": "Daten aus Marge und Kostendaten · {range}",
  "pa.toReport": "In den Report",
  "pa.kpi.ns": "Umsatz {y}",
  "pa.kpi.hours": "{h} Stunden",
  "pa.kpi.cost": "Projektkosten {y}",
  "pa.kpi.margin": "Marge {y}",
  "pa.kpi.target": "Ziel {p}",
  "pa.kpi.last": "Marge {m}",
  "pa.kpi.noPrev": "kein Vormonat",
  "pa.kpi.pts": "{d} Punkte zum {m}",
  "pa.ptsShort": "{d} Pkt.",
  "pa.group.personnel": "Personal",
  "pa.group.subcontracting": "Subunternehmer",
  "pa.group.other": "Sonstige",
  "pa.costs": "Projektkosten",
  "pa.chart": "Umsatz, Kosten und Marge je Monat",
  "pa.chartHint": "Monat anklicken für die Analyse",
  "pa.chartPct": "Zahl oben = Marge %",
  "pa.open": "offen",
  "pa.pick": "Analyse {m}",
  "pa.openMonth": "{m} noch offen",
  "pa.marginOf": "Marge {m}",
  "pa.what": "Was ist passiert? · {cur} gegenüber {prev}",
  "pa.auto": "automatisch erstellt · erscheint so im Report",
  "pa.sev.critical": "Handlungsbedarf",
  "pa.sev.watch": "beobachten",
  "pa.sev.info": "Hinweis",
  "pa.sev.ok": "unauffällig",
  "pa.noDetail": "Ohne Kostendetail ({m}): Für mindestens einen der Monate gibt es nur die Projektkosten gesamt aus dem Marge-Export. Brücke und Auffälligkeiten vergleichen dann nur die Summe.",
  "pa.bridge": "Margenbrücke {from} → {to}",
  "pa.bridgeHint": "Grün = verbessert die Marge, rot = verschlechtert sie. Kosten als Veränderung zum Vormonat.",
  "pa.perf": "Leistung im Vergleich",
  "pa.perHourNs": "Umsatz je Stunde",
  "pa.perHourCost": "Kosten je Stunde",
  "pa.comment": "Kommentar PM",
  "pa.commentHint": "optional · erscheint hier, in der Marge-Übersicht und im Report",
  "pa.commentPh": "z. B. Zwei Entwickler im Urlaub; Abnahme Sprint 18 auf Oktober verschoben",
  "pa.commentMeta": "{by} · {at} · zu {m}",
  "pa.commentSave": "Kommentar speichern",
  "pa.commentDelete": "Kommentar löschen",
  "pa.table": "Kostenaufschlüsselung",
  "pa.tableHint": "in T€ · Kostenart aufklappen für die Einzelposten",
  "pa.col.kind": "Kostenart",
  "pa.col.share": "Anteil",
  "pa.noDetailMonths": "* ohne Kostendetail: {m} – nur Projektkosten gesamt aus dem Marge-Export (als Sonstige).",
  "pa.noCostData": "Für dieses Projekt gibt es noch keine Kostendaten; die Projektkosten stammen aus dem Marge-Export (als Sonstige).",
  "rp.topic.analysis": "Marge & Projekt-Analyse",
  "rp.an.which": "Welche Projekte bekommen eine eigene Folie?",
  "rp.an.mode.critical": "Nur Handlungsbedarf",
  "rp.an.mode.focus": "Handlungsbedarf + beobachten",
  "rp.an.mode.all": "Alle Projekte",
  "rp.an.modeHint": "{n} von {all} Projekten: {list}. Die übrigen erscheinen nur in der Bereichsseite.",
  "rp.an.parts": "Inhalte",
  "rp.an.part.area": "Bereichsseite „Was hat sich verändert?“",
  "rp.an.part.summary": "Zusammenfassung in Klartext",
  "rp.an.part.bridge": "Margenbrücke",
  "rp.an.part.perf": "Leistung im Vergleich",
  "rp.an.part.finds": "Auffälligkeiten",
  "rp.an.part.comment": "Kommentar des PMs",
  "rp.an.part.costs": "Kostenaufschlüsselung als Anhang",
  "rp.an.partDesc.area": "Margenbrücke nach Projekten und die 3 wichtigsten Sätze",
  "rp.an.partDesc.summary": "je Projekt 2–3 Sätze",
  "rp.an.partDesc.bridge": "Vormonat → Umsatz → Personal → Sub → Sonstige → aktuell",
  "rp.an.partDesc.perf": "Stunden, Umsatz und Kosten je Stunde",
  "rp.an.partDesc.finds": "die wichtigsten 3, nach Schwere sortiert",
  "rp.an.partDesc.comment": "wenn erfasst",
  "rp.an.partDesc.costs": "je Projekt eine Folie mit Kostenarten × Monat",
  "rp.an.noData": "Noch keine Margendaten. Bitte auf der Seite Marge den Power-BI-Export einlesen.",
  "rp.an.key": "Das Wichtigste",
  "rp.an.appendix": "Anhang · Kostenarten je Monat",
  // Protokoll (Aktivitätsprotokoll)
  "admin.tab.log": "Protokoll",
  "log.title": "Protokoll",
  "log.lead": "Wer hat wann was im Tool gemacht: Anmeldungen, Seitenaufrufe, Änderungen, Importe, Exporte, Verwaltung und abgewiesene Zugriffe – über alle Bereiche. Einträge können nicht geändert oder gelöscht werden.",
  "log.from": "Von",
  "log.to": "Bis",
  "log.person": "Person",
  "log.action": "Aktion",
  "log.entity": "Eintragstyp",
  "log.area": "Bereich",
  "log.via": "Zugang",
  "log.result": "Ergebnis",
  "log.ok": "OK",
  "log.failed": "Fehlgeschlagen",
  "log.searchPh": "Bestellnummer, Projekt, Text …",
  "log.apply": "Anzeigen",
  "log.export": "Als Excel",
  "log.empty": "Für diese Auswahl gibt es keine Einträge.",
  "log.more": "Weitere 100 laden",
  "log.anonymous": "nicht angemeldet",
  "log.col.time": "Zeit",
  "log.col.what": "Was",
  "log.col.item": "Eintrag",
  "log.col.result": "Ergebnis",
  "log.col.changes": "Feldänd.",
  "log.help": "Klick auf eine Zeile zeigt Einzelheiten und die Feldänderungen (vorher/nachher) derselben Anfrage. Der Excel-Bericht enthält alle Einträge der gewählten Filter (bis 50 000).",
  "log.entry": "Protokolleintrag",
  "log.planned": "geplant",
  "log.request": "Anfrage",
  "log.requestId": "Anfrage-ID",
  "log.ch.what": "Änderung",
  "log.ch.field": "Feld",
  "log.ch.before": "Vorher",
  "log.ch.after": "Nachher",
  "uf.logAccess": "Protokoll: darf das Aktivitätsprotokoll sehen und als Bericht ziehen",
  "uf.logAccessHelp": "Nur wer das Häkchen selbst hat, kann es vergeben oder entziehen; sich selbst entziehen geht nicht.",
  "uf.logAccessShort": "Protokoll",
  "log.leadChanges": "Wer hat was angelegt, geändert, gelöscht, wiederhergestellt oder importiert – über alle Bereiche. Klick auf eine Zeile zeigt die Felder vorher/nachher.",
  "log.leadErrors": "Was nicht funktioniert hat: Serverfehler, Konflikte (jemand anderes hatte den Eintrag inzwischen geändert), abgewiesene Zugriffe und ungültige Eingaben – mit Zeitpunkt, Person und Grund.",
  "log.leadAll": "Jede Anfrage an das Tool: auch Seitenaufrufe, Exporte, Anmeldungen und Abgleiche.",
  "log.view": "Sicht",
  "log.viewChanges": "Änderungen",
  "log.viewErrors": "Fehler",
  "log.viewAll": "Alles",
  "log.recent": "Letzte 7 Tage: {n} fehlgeschlagen – {e} Serverfehler, {c} Konflikte, {d} abgewiesen, {i} ungültig",
  "log.recentNone": "Letzte 7 Tage: nichts fehlgeschlagen",
  "log.recentHelp": "Fehlgeschlagene Anfragen der letzten 7 Tage, unabhängig vom gewählten Zeitraum",
  "log.col.reason": "Grund",
  "log.helpErrors": "Klick auf eine Zeile zeigt die Anfrage, den Grund und bei Serverfehlern den Aufrufstapel. Serverfehler (500) sind Fehler im Tool; Konflikte (409) und ungültige Eingaben (400) sind Hinweise aus der Bedienung; abgewiesen (403) heißt fehlende Rechte.",
  "log.stack": "Technische Einzelheiten (Aufrufstapel)",
};

export type Key = keyof typeof de;
